import React from 'react';
import { useInputs } from 'hooks/useInputs';

import Table from '../../components/Table';

function Inputs() {
  const {
    inputs,
    CustomTitle,
    exportData,
    openProgress,
    columns,
    columnsForExport,
    errors,
    errorsWhenPosting,
    pond,
    handleImportDataPost,
    handleCloseSnackbar,
    searchText,
  } = useInputs();

  return (
    <Table
      onPost={handleImportDataPost}
      title="Consumo"
      titleCustomized={<CustomTitle />}
      route="/inputs/"
      routeAdd="/input/"
      columns={columns}
      columnsForExport={columnsForExport}
      data={inputs}
      dataLoaded={openProgress}
      exportData={exportData}
      hasError={errors.length > 0}
      importButtonVisible
      errorsPost={errorsWhenPosting}
      onCloseSnackbar={handleCloseSnackbar}
      pond={pond}
      searchText={searchText}
    />
  );
}

export default Inputs;
